__turbopack_context__.v({
  "panel": "TabbedNavigation-module__jLWu8W__panel",
  "root": "TabbedNavigation-module__jLWu8W__root",
  "tabNavigation": "TabbedNavigation-module__jLWu8W__tabNavigation",
});
